var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    class: _vm.$style.container
  }, [_c('MileCountdown', {
    attrs: {
      "height": 300
    }
  })], 1), _c('div', {
    class: _vm.$style.container2
  }, [_c('MileCountdown', {
    attrs: {
      "height": 150
    }
  })], 1), _c('div', {
    class: _vm.$style.container3
  }, [_c('MileCountdown', {
    attrs: {
      "height": 78
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }